import { ComponentPropsWithoutRef } from 'react';
import { Typography } from '../../../ui';

export function Heading4(props: ComponentPropsWithoutRef<'h4'>) {
  const { children, ...rest } = props;

  return (
    <Typography
      as="h4"
      variant="body-s"
      weight="medium"
      className="text-grayscale600"
      {...rest}
    >
      {children}
    </Typography>
  );
}
